import { useRef } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DropdownSelect } from "@/components/ui/dropdown-select"
import { UploadFormData } from "@/modules/upload/schema/upload-schema"
import { MedicalReportTypeValues } from "@/types/__generated__/union-types"

export const DocumentTypeSelector = () => {
  const { t } = useTranslation()
  const form = useFormContext<UploadFormData>()
  const documentTypes = useRef(
    MedicalReportTypeValues.map((m) => ({
      label: t(`episodeOfCare.progressNote.${m === "OTHER" ? "otherDocument" : "medicalReport"}`),
      value: `${m}`,
    })),
  ).current

  return (
    <Controller
      name="documentType"
      control={form.control}
      render={({ field: { value, onChange, ref } }) => (
        <DropdownSelect
          className="px-0.5"
          testId="medical-report-type-dropdown"
          defaultValue={value}
          onSelect={onChange}
          label={`${t("episodeOfCare.progressNote.documentType")}*`}
          options={documentTypes}
          ref={ref}
        />
      )}
    />
  )
}
